exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new-status-info{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px}.new-status-info header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.new-status-info .status-change-criteria{flex:0 0 auto;width:calc(99.99% * 2/3 - 6.666666666666666px)}.new-status-info .status-change-criteria:nth-child(1n){margin-right:20px}.new-status-info .status-change-criteria:last-child{margin-right:0}.new-status-info .status-change-criteria:nth-child(3n){float:right;margin-right:0}.new-status-info .status-change-criteria a{font-size:medium}.new-status-info .status-change-criteria textarea{min-height:200px}.new-status-info .status-change-criteria .help-text{font-size:1.2rem;text-align:justify}.new-status-info .status-change-criteria .status-change-damaged-eoos .key-value-radio-list{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/product/status-change-request/components/new-status-info.scss
// module id = 5159
// module chunks = 0